module.exports = __webpack_public_path__ + "img/3.847dbe67.png";